import CustomLink from './CustomLink'
import InstallApp from '../install-app/InstallApp'
import React from 'react'
import './Header.css'
// import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
const Header = () => {

  return (
    <header>
      {/* Free-delivery badge - disabled for now (not offering it yet). Kept
          here, ready to re-enable: it's already styled in Header.css to pin
          to the left edge instead of sitting inline next to the logo. */}
      {/* <div className='delivery'>
        <p>משלוח חינם מעל 200 שקל</p>
        <DeliveryDiningIcon className='delivery_icon'/>
      </div> */}
      <InstallApp />
      <CustomLink to={'/'}>
        <img src='/image/logo-v2.jpg' alt="היהלומים של קרן" className='icon'/>
      </CustomLink>
    </header>
  )
}

export default Header
